import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { getTranslation } from "utilities/articleUtils";
import { getArticleUrl } from "../../../supportbeacon/model";
import { DetailSidePanel } from "../DetailSidePanel";
import { SupportSidePanelDetails } from "./SupportSidePanelDetails";

interface SupportSidePanelProps {
  articleId: number
  trigger: React.ReactElement
}

export const SupportSidePanel = (props: SupportSidePanelProps) => {
  const { articleId } = props;

  return <DetailSidePanel
    apiCall={() => window.CoreApi.Article.GetArticle(articleId)}
    apiKey="support-article"
    entityId={articleId}
    title={RESX.Feed.Support}
    footerContent={article => <>
      <ButtonPrimary
        label={RESX.GeneralLabels.ReadMore}
        href={getArticleUrl(article.articleId, getTranslation(article.translations).slug)}
        target="_blank"
      />
    </>}
    trigger={props.trigger}
  >
    {article => <SupportSidePanelDetails article={article} />}
  </DetailSidePanel>
}
